import React, { FC } from 'react';

// Components
import { TournamentInfo } from './TournamentInfo/TournamentInfo';

// Types
import { ISubscriberInfo } from '../../../../../../packages/types';
import { INormalizeTournament } from '../../../types';

interface Props {
  tournamentOne: INormalizeTournament;
  tournamentTwo: INormalizeTournament;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const TournamentComparisonHeader: FC<Props> = ({ tournamentOne, tournamentTwo, handleClick }) => {
  return (
    <div className='tournament-comparison-container flex justify-between bg-subHeaderBgColor gap-2 p-2'>
      <TournamentInfo tournament={tournamentOne} handleClick={handleClick} />
      <TournamentInfo tournament={tournamentTwo} withReversedDisplay handleClick={handleClick} />
    </div>
  );
};
